if (!customElements.get('countdown-banner')) {
  customElements.define(
    'countdown-banner',
    class CountdownBanner extends HTMLElement {
      constructor() {
        super();
        this.targetDate = null;
      }
    
      connectedCallback() {
        if (document.readyState === 'complete') {
          this.init();
          return;
        }
        
        document.addEventListener('DOMContentLoaded', () => {
          this.init();
        });
      }
      
      init() {
        this.hideOnCompletion = this.dataset.hideOnCompletion === 'true';
        this.targetDate = new Date(this.dataset.dateString);
        this.days = this.querySelector('[data-days]');
        this.hours = this.querySelector('[data-hours]');
        this.minutes = this.querySelector('[data-minutes]');
        this.seconds = this.querySelector('[data-seconds]');

        this.interval = setInterval(() => {
          this.tick();
        }, 1000);
      }
      
      tick() {
        const difference = this.targetDate.getTime() - new Date().getTime();
        if (difference <= 0) {
          clearInterval(this.interval);
          if (this.hideOnCompletion) {
            this.remove();
            return;
          }
          
          this.days.innerHTML = '0d';
          this.hours.innerHTML = '0h';
          this.minutes.innerHTML = '0m';
          this.seconds.innerHTML = '0s';
          return;
        }
        
        const daysDiff = Math.floor(difference / (1000 * 60 * 60  * 24));
        const hoursDiff = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutesDiff = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const secondsDiff = Math.floor((difference % (1000 * 60)) / 1000);
      
        this.days.innerHTML = `${daysDiff}d`;
        this.hours.innerHTML = `${hoursDiff}h`;
        this.minutes.innerHTML = `${minutesDiff}m`;
        this.seconds.innerHTML = `${secondsDiff}s`;
      }
    }
  );
}